export default __webpack_public_path__ + "static/media/unselect_Redo.52baa179.svg";